export default __webpack_public_path__ + "static/media/icon_editor_file.44357980.svg";